import XGrid from "@/components/grid/XGridChild";
import {CONSTANT as constant} from '@/services/constant';
import api from "@/services/api";
import {dataApi} from "@/services/exportSource";
import XEUtils from "xe-utils";
import {mapGetters} from "vuex";

const GridChildMixin = {
	name: 'xGridList',
	components: {
		XGrid,
	},
	/**
	 * 将当前用户加载到页面中
	 */
	computed: {
		...mapGetters('account', ['user'])
	},
	props: {
		rowId: {
			default: ''
		},
		num: {
			default: Infinity
		},
		accept: {
			default: '*'
		},
		url: {
			default: ''
		}
	},
	data() {
		return {
			params: this.$route.query,
			api,
			constant,
			$refType: 'childTable',
			rowIdName: 'id',
			editRowId: 0,//编辑单据主键
			editModalVisible: false,
			visible: false,//弹出选择窗的显示状态
			list: [],
			action: api.temp.UPLOAD_PATH,
			headers: {
				token: localStorage.getItem('token') || ''
			},
			// fileList: [],
			// filePath: '',
		}
	},
	methods: {
		/**
		 * 重新上传行的文件
		 */
		uploadRowsFile(url, row, type) {
			let list = this.$refs['grid'].$refs['xGrid'].getTableData().fullData;
			list.forEach(item => {
				if (item['_XID'] === row['_XID']) {
					item[type] = url;
				}
			})
			this.list = list;
			this.refresh();
		},
		/**
		 * 打开加载/关闭加载
		 * @param status
		 */
		loading(status) {
			this.$refs['grid'].loading = status;
		},
		refresh() {
			this.$refs['grid'].$refs['xGrid'].reloadData(this.list);
		},
		closeEdit(refresh) {
			if (refresh === true) {
				this.refresh();
			}
			this.editRowId = -1;
			this.editModalVisible = false;
		},
		openEdit(keyId) {
			this.editRowId = keyId;
			this.editModalVisible = true;
		},
		editRow(row) {
			this.openEdit(row[this.rowIdName]);
		},
		/**
		 * 编辑完成后通知父组件
		 * @param evt
		 */
		endEdit(evt) {
			//这里清除掉了弹出层内的默认值以及弹出子表内的选中数据
			this.beforeClose().finally(() => {
				this.$emit(evt, this.rowId);
			})
		},
		cellDbClick({row}) {
			this.editRow(row)
		},
		/**
		 * 设置子表的值 通用写法
		 */
		setFormChangeData(list) {
			this.list = list;
			this.$refs['grid'].$refs['xGrid'].loadData(list);
		},

		/**
		 * 加载从主表过来的数据 固定写法
		 */
		loadData(list = []) {
			this.list = list;
			this.$refs['grid'].$refs['xGrid'].loadData(list);
		},
		/**
		 * 增加行
		 * @param any 对象或数组类型 如不填默认增加一行 如果any为pop 则表示打开弹出层
		 */
		addRow(any) {
			if (any === 'pop') {
				this.visible = true
			} else {
				this.$refs['grid'].insertAt(any || {}, -1)
				this.list.push(any || {})
			}
		},

		/**
		 * 获取行
		 * @return {RowInfo[] | []}
		 */
		getRows() {
			return this.$refs['grid'].$refs['xGrid'].getCheckboxRecords()
		},

		/**
		 * 调用子表弹出层回传数据方法 固定写法
		 */
		handleOk(ref) {
			this.$refs[ref].getSelectData();
			this.visible = false;
		},
		/**
		 * 清理子表弹出层选中状态 固定写法
		 */
		handleClose(ref) {
			this.$refs[ref].$refs['grid'].clearTable();
		},
		/**
		 * 方法名要与弹出层表格一致 建议固定
		 * 获取子表弹出层的数据并插入子表
		 * 调用FormChildTable.insertRow方法 将处理字段传入方法 对回调数据进行过滤或调整
		 */
		getTableData(res, type) {
			console.info('不含有表格回调方法', res, type)
		},
		/**
		 * 给主表返回数据 固定写法
		 */
		getChildData(callback) {
			// let err;
			// this.$refs['grid'].$refs['xGrid'].validate(false,e=>{
			// 	err = e;
			// });
			// if (err){
			// 	throw '必填项未填写完成'
			// }else{
			let dataArr = this.$refs['grid'].$refs['xGrid'].getTableData().fullData;
			let delArr = this.$refs['grid'].$refs['xGrid'].getRemoveRecords();
			if (typeof callback == "function") {
				dataArr.forEach(v => {
					v[this.rowIdName] = v[this.rowIdName] <= 0 ? '' : v[this.rowIdName]
				})
				delArr.forEach(v => {
					v[this.rowIdName] = v[this.rowIdName] <= 0 ? '' : v[this.rowIdName]
				})
				callback(dataArr, delArr);
			}
			// }

		},
		/**
		 * 删除选中行 固定写法
		 * callback 删除后执行回调
		 */
		delRow(callback) {
			this.$refs['grid'].$refs['xGrid'].removeCheckboxRow().then(() => {
				callback?callback():''
			});
		},

		/**
		 * 文件上传回调
		 */
		handleChange({file, fileList}) {
			this.loading(true)
			if (fileList.length > this.num) {
				fileList = fileList.slice(0, this.num);
			}
			// this.fileList = fileList;
			if (file.status === 'done') {
				let arr = fileList.filter(v => {
					return v.response
				}).map(v => {
					return v.response.data
				});
				if (arr.length === fileList.length) {
					this.loading(false);
					this.$message.success('上传成功');
					this.list = arr;
					this.refresh()
				}
			} else if (file.status === 'error') {
				this.loading(false);
				this.$message.error('上传失败')
			}
		},
		async exportMethod(url, options) {
			let defaultName = '导出-' + XEUtils.toDateString(new Date(), 'yyyyMMddHHssmm');
			options = {
				filename: options && options.filename ? options.filename : defaultName,
				sheetName: options && options.sheetName ? options.sheetName : 'Sheet1',
				containHeader: options && options.isHeader ? options.isHeader : false,
				original: options && options.original ? options.original : true,
			}
			let columns = this.$refs['grid'].$refs['xGrid'].getColumns();
			// 传给服务端的参数
			const body = {
				filename: options.filename,
				sheetName: options.sheetName,
				containHeader: options.containHeader,
				original: options.original,
				fields: columns.map(column => {
					return {
						field: column.property,
						title: column.title
					}
				})
			}
			// 开始服务端导出
			await dataApi.exportFile(url, body).then(blob => {
				this.$message.success('导出成功，开始下载');
				let downloadElement = document.createElement("a");
				let href = window.URL.createObjectURL(blob.data); //创建下载的链接
				downloadElement.href = href;
				downloadElement.download = options.filename + '.xlsx'; //下载后文件名
				document.body.appendChild(downloadElement);
				downloadElement.click(); //点击下载
				document.body.removeChild(downloadElement); //下载完成移除元素
				window.URL.revokeObjectURL(href); //释放掉blob对象
			}).catch(e => {
				console.error('导出失败:' + e);
				this.$message.error('导出失败');
			})
		},
	}

}

export {
	GridChildMixin
}